import InternalStorageBaseScreen from "../../shared/internalStorage/InternalStorageBaseScreen";

export const InternalStorageBase = ({ modalData }: { modalData: any }) => (
  <InternalStorageBaseScreen modalData={modalData} gate="farm" variant="mapping" />
);
